import React, { useState, useEffect } from 'react'
import { Button, Modal, Form, Input, Select } from 'antd';
import '../../../App.css'

function EditAgModal({ info, onSubmit, onDelete, open, setOpen }) {
    const [form] = Form.useForm();
    const [isDisabled, setIsDisabled] = useState(true);

    useEffect(() => {
        if (info.name) {
            setOpen(true)
        }
    }, [info])

    useEffect(() => {
        form.setFieldsValue(info)
    }, [info, form])

    const showModal = () => {
        setIsDisabled(false)
        form.setFieldsValue({
            key: `${new Date().getTime()}`,
            name: null,
        })
        setOpen(true);
    };

    const handleCancel = () => {
        setOpen(false);
    };

    const onFinish = (data) => {
        onSubmit(data);
    };

    const deleteStatAg = () => {
        onDelete(form.getFieldsValue());
    };

    return (
        <>
            <Button type="primary" onClick={showModal}>
                New Entry
            </Button>
            <Modal
                open={open}
                title={'Edit State Agency'}
                onCancel={handleCancel}
                width={750}
                footer={null}
            >
                <div>
                    <Form
                        layout={'horizontal'}
                        form={form}
                        labelCol={{ span: 5 }}
                        wrapperCol={{ span: 20 }}
                        style={{
                            maxWidth: 700,
                        }}
                        onFinish={onFinish}
                    >
                        <Form.Item label="ID" name='key'>
                            <Input disabled={true} />
                        </Form.Item>
                        <Form.Item label="Name" name='name'>
                            <Input />
                        </Form.Item>
                        <Form.Item style={{ marginLeft: 160 }}>
                            <Button type='primary' htmlType='submit' style={{ width: 200 }}>
                                Save
                            </Button>
                            <Button danger onClick={deleteStatAg} style={{ marginLeft: 10, width: 200 }}>
                                Delete
                            </Button>
                        </Form.Item>
                    </Form>
                </div>
            </Modal>
        </>
    );
}

export default EditAgModal

